module.exports = __webpack_public_path__ + "img/login.f95f7be3.jpg";